import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { isMobile } from 'react-device-detect';

type Props<T> = { value?: T; errorMessage: string; onClick?: (v?: T) => void };

const ErrorToast = <T,>({ value, onClick, errorMessage }: Props<T>) => {
  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: isMobile ? 'top' : 'bottom', horizontal: 'center' }}
      autoHideDuration={5000}
    >
      <Alert variant="filled" severity="error" onClick={() => (onClick ? onClick(value) : undefined)}>
        {errorMessage}
      </Alert>
    </Snackbar>
  );
};

export default ErrorToast;
